import { Box, CircularProgress } from '@mui/material';

/**
 * A loading component that displays during initialization
 * Rendered only on client-side to prevent hydration mismatches
 */
export default function LoadingFallback() {
  return (
    <Box
      sx={{
        height: 'calc(100vh - 96px)',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  );
}
